import { render, staticRenderFns } from "./CoveragePerformanceCriteria.vue?vue&type=template&id=77b31958&scoped=true&"
import script from "./CoveragePerformanceCriteria.vue?vue&type=script&lang=js&"
export * from "./CoveragePerformanceCriteria.vue?vue&type=script&lang=js&"
import style0 from "./CoveragePerformanceCriteria.vue?vue&type=style&index=0&id=77b31958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b31958",
  null
  
)

export default component.exports